import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Truncate from 'react-truncate';
import { getOnboardingState, getAuthState } from '../../store/selectors';
import { getCurrentUserId, getData } from '../../store/actions';
import BuildCareerButton from './utility/BuildCareerButton';
import EditCareerPathLink from './utility/EditCareerPathLink';
import ExpandInfoLink from './utility/ExpandInfoLink';
import PathChosenAddon from './utility/PathChosenAddon';
import InformationIcon from '../utility/InformationIcon';
import { modalOpen_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import Favorite from '../utility/Favorite';
import SunIcon from '../utility/SunIcon.jsx';

// TODO: Convert this to class component with state and save
function CareerPathCard(props) {
  const cardPrimaryBorderBottom = {
    color: `${props.tenant.secondary}`,
  };

  const careerCardBackgroundColor = {
    backgrounColor: `${props.tenant.secondary}`,
  };

  // How many degree-pairings does the user have?
  const checkPathsChosen = () => {
    const pathsChosen = Object.values(props.onboarding.degreeChoices).filter(
      (degreeChoice) => {
        return degreeChoice.id;
      }
    );
    return pathsChosen.length;
  };

  // Needed for conditional styling of a card's alignment
  const degreePathAdded =
    props.onboarding.degreeChoices[props.tabNumber] !== ''
      ? 'yellow-degree-path-added'
      : '';

  const checkShowSunIcon = (buttonOrEditProps) => {
    if (
      buttonOrEditProps &&
      (Object.values(props.onboarding.degreeChoices).indexOf('') > -1 ||
        buttonOrEditProps.isListOpen())
    )
      return;

    const allPathsChosen = checkPathsChosen() === 3;

    if (props.career.careerOutlook)
      return (
        <SunIcon
          setParentOnClick={props.setBrightOutlookModal}
          additionalClassName={
            allPathsChosen ? 'all-paths-chosen' : 'button-edit-missing'
          }
        />
      );
  };

  const handleIconClick = () => {
    props.history.push(
      `${props.location.pathname}?career=${encodeURIComponent(
        props.career.titleEn
      )}`
    );
  };

  const chooseButtonOrEditLink = (buttonOrEditProps) => {
    const pathsChosen = checkPathsChosen();
    // Is there a degreeChoice that hasn't been paired yet?
    if (
      buttonOrEditProps.onboarding.degreeChoices[
        buttonOrEditProps.tabNumber
      ] === ''
    ) {
      return (
        <BuildCareerButton
          career={props.career}
          overRideStyle="build-career-button"
          careerProps={buttonOrEditProps}
          tenant={props.tenant}
          modalImage={props.image}
          shortenButtonText={props.shortenButtonText}
          setBrightOutlookModal={props.setBrightOutlookModal}
        />
      );
    }

    // Are we missing a degree-path pairing and is a career-path card currently open?
    if (
      (pathsChosen < 3 &&
        buttonOrEditProps.onboarding.careerTabSelected !== true) ||
      // Are we missing a degree-path pairing and is the list of careers closed?
      (pathsChosen < 3 && buttonOrEditProps.openList === false)
    ) {
      buttonOrEditProps.isListOpen();

      return (
        <div className="edit-career-icon-container">
          <EditCareerPathLink
            pathname={props.pathname}
            tabNumber={buttonOrEditProps.tabNumber}
            tenant={props.tenant}
            modalImage={props.image}
            career={props.career}
            setBrightOutlookModal={props.setBrightOutlookModal}
          />
        </div>
      );
    }

    if (pathsChosen === 3) {
      buttonOrEditProps.isListOpen();

      return (
        // Needed for spacing consistency within the card
        <div className="degree-chosen-icon-container"> </div>
      );
    }

    buttonOrEditProps.isListOpen();

    return (
      <div className="outlook-info-icon">
        {checkShowSunIcon()}
        <button
          className="info-button focus-indicator"
          type="button"
          data-cy="info-button"
          id={`info-${props.career.titleEn}`}
          onClick={() => {
            handleIconClick();
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) handleIconClick();
          }}
        >
          <InformationIcon
            color={props.tenant.primary}
            gtmObj={modalOpen_GTM}
            text="information"
            section={props.career.titleEn}
            modalImage={props.image}
          />
        </button>
      </div>
    );
  };

  // If all paths have been paired and no career card is currently selected/active, show the 'Expand Info' link \
  // along with the short text summary of the degree path
  const showExpandInfoLink = (expandInfoProps) => {
    if (checkPathsChosen() === 3) {
      return (
        <ExpandInfoLink
          expandInfoLink={expandInfoProps.expandInfoLink}
          tabNumber={expandInfoProps.tabNumber}
          tenant={props.tenant}
          setParentOnClick={props.setBrightOutlookModal}
        />
      );
    }

    return null;
  };

  const showPathChosenAddon = (pathAddonProps) => {
    if (
      pathAddonProps.onboarding.degreeChoices[pathAddonProps.tabNumber] !==
        '' &&
      pathAddonProps.cardSelected !== true
    ) {
      return (
        <PathChosenAddon
          tabNumber={pathAddonProps.tabNumber}
          tenant={props.tenant}
          modalImage={props.image}
        />
      );
    }

    return null;
  };

  return props.image !== undefined ? (
    <div
      className={`${props.classActive} ${degreePathAdded}`}
      data-cy="career-path-card"
    >
      <div
        className={`career-card-content ${
          degreePathAdded ? 'degree-path-added' : ''
        }`}
      >
        <img
          className={`card-image ${
            degreePathAdded === 'yellow-degree-path-added'
              ? 'modify-image-border'
              : ''
          }`}
          src={props.image}
          alt={`${props.career.titleEn}`}
          width="800"
          height="400"
        />
        <div className="career-card-favorite-container">
          <Favorite
            careerId={props.career.id}
            careerName={props.career.titleEn}
            career={props.career}
          />
        </div>
        <div
          className={`button-career-text-container ${degreePathAdded}`}
          style={cardPrimaryBorderBottom}
        >
          <h3 className="career-text">{props.career.titleEn}</h3>
          {checkShowSunIcon(props)}
          {chooseButtonOrEditLink(props)}
        </div>
      </div>
      <div
        className="career-card-content-info"
        style={careerCardBackgroundColor}
      >
        {showExpandInfoLink(props)}
      </div>
      {/* Display the 'degree title' and the 'deselect path link' */}
      {showPathChosenAddon(props)}
    </div>
  ) : null;
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { onboarding, auth };
}

export default withRouter(
  connect(mapStateToProps, {
    getCurrentUserId,
    getData,
  })(CareerPathCard)
);
